<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <h4 class="title" v-if="discount && discount.code">
        Bookings using <strong>{{ discount.code }}</strong> discount
      </h4>
      <h4 class="title" v-else>Bookings using this discount</h4>
    </md-card-header>
    <md-card-content>
      <md-table :value="bookings" md-card>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Booking ID">
            <router-link
              v-if="item && item.id"
              :to="{ name: 'Booking Profile', params: { id: item.id } }"
            >
              {{ item.id }}
            </router-link>
            <span v-else>-</span>
          </md-table-cell>
          <md-table-cell md-label="Tour">
            <router-link
              v-if="getTourId(item) !== '-' && getAdventureTitle(item) !== '-'"
              :to="{
                name: 'Adventure Profile',
                params: { tour_id: getTourId(item) }
              }"
            >
              {{ getAdventureTitle(item) }}
            </router-link>
            <span v-else>-</span>
          </md-table-cell>
          <md-table-cell md-label="Date Booked">
            {{ item.booking_date | formatDate }}
          </md-table-cell>
          <md-table-cell md-label="Departure">
            {{ getDepartureDate(item) }}
          </md-table-cell>
        </md-table-row>

        <md-table-empty-state
          md-label="No Bookings"
          :md-description="`No bookings use this discount yet.`"
        />
      </md-table>
    </md-card-content>
  </md-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["discount"],

  watch: {
    "discount.id": {
      handler() {
        this.fetchDiscountBookings(this.discount?.id);
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters("discount", ["discountBookings"]),
    bookings() {
      return this.discountBookings || [];
    }
  },

  methods: {
    ...mapActions("discount", ["fetchDiscountBookings"]),

    getAdventureTitle(item) {
      const tour = item?.departure?.tour;
      if (typeof tour === "string") return tour;
      return tour?.title || "-";
    },

    getTourId(item) {
      return item?.departure?.tour_id ?? "-";
    },

    getDepartureDate(item) {
      if (!item?.departure?.start_date) return "-";
      const formatDate = this.$options.filters?.formatDate;
      return formatDate ? formatDate(item.departure.start_date) : "-";
    }
  }
};
</script>
